'use client';

import { useEffect, useRef, useState } from 'react';

export function useSection() {
	const sectionRef = useRef<HTMLElement>(null);
	const [height, setHeight] = useState('100vh');

	useEffect(() => {
		// Check if we're in the browser
		if (typeof window === 'undefined') return;

		const updateHeight = () => {
			if (!sectionRef.current) return;

			const viewportHeight = window.innerHeight;
			const sectionContent = sectionRef.current.firstElementChild as HTMLElement;
			if (!sectionContent) return;

			const contentHeight = sectionContent.scrollHeight;
			const minHeight = Math.max(viewportHeight, contentHeight);

			setHeight(`${minHeight}px`);
		};

		updateHeight();
		window.addEventListener('resize', updateHeight);

		// Also update after images load
		const images = sectionRef.current?.getElementsByTagName('img');
		if (images) {
			Array.from(images).forEach(img => {
				if (img.complete) {
					updateHeight();
				} else {
					img.addEventListener('load', updateHeight);
				}
			});
		}

		return () => {
			window.removeEventListener('resize', updateHeight);
			if (images) {
				Array.from(images).forEach(img => {
					img.removeEventListener('load', updateHeight);
				});
			}
		};
	}, []);

	return { sectionRef, height };
}
